<template>
  <div>
    <v-dialog v-model="show" v-bind="$attrs" persistent fullscreen>
      <v-card>
        <v-card-title class="justify-center">
          <v-progress-circular
            indeterminate
            :size="70"
            :width="7"
            color="primary"
            class="mt-16"
          ></v-progress-circular>

          <div class="font-italic font-weight-bold mt-5 pt-10">
            {{ $t("message.auto_redirect_after_paid") }}
          </div>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" small @click.stop="show = false">
            <v-icon>{{ mdiClose }}</v-icon
            >{{ $t("label.cancel") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <snackbar-msg
      v-model="snackBarMsg.show"
      :text="snackBarMsg.text"
      :color="snackBarMsg.color"
    ></snackbar-msg>
  </div>
</template>

<script>
import { mdiClose, mdiLineScan } from "@mdi/js";
import { InquiryPayment } from "@/api/publicServices";

export default {
  props: {
    value: Boolean,
    paymentId: {
      type: String,
      required: true,
    },
    interval: {
      type: Number,
      required: true,
    },
  },
  components: {},
  computed: {
    show: {
      get() {
        console.log("get: " + this.value);
        return this.value;
      },
      set(value) {
        console.log("set: " + value);
        this.reset();
        this.$emit("input", value);
      },
    },
  },
  data: () => ({
    polling: null,
    pollingNo: 0,

    snackBarMsg: {
      show: false,
      text: "",
      color: "red",
    },

    //svg icons
    mdiClose,
    mdiLineScan,
  }),
  methods: {
    async inquiryPayment() {
      try {
        let data = { PaymentID: this.paymentId };
        this.pollingNo++;
        console.log("pollingNo: ", this.pollingNo);
        if (this.pollingNo > 11) {
          data.CallInquiryApi = true;
          console.log("data: ", data);
        }
        const response = await InquiryPayment(data);
        if (response.data.isSuccess) {
          this.updatePaymentStatus(true);
          console.log(response.data);
        } else if (response.data.Key == "FAIL") {
          this.updatePaymentStatus(false);
          console.log(response.data);
        }
      } catch (error) {
        // this.snackBarMsg.text = "Service Error";
        // this.snackBarMsg.show = true;
        console.log(error);
      }
    },
    updatePaymentStatus(status) {
      this.reset();
      console.log("dialog emit: updatePaymentStatus");
      this.show = false;
      this.$emit("onPayment", { paymentStatus: status });
    },
    reset() {
      console.log("reset");
      this.pollingNo = 0;
      if (this.polling != null) clearInterval(this.polling);
    },
    pollQuery() {
      this.polling = setInterval(() => {
        console.log("pollData");
        this.inquiryPayment();
      }, this.interval);
    },
  },
  mounted() {},
  beforeDestroy() {
    console.log("destroy");
    this.reset();
  },
};
</script>
